/* eslint-disable no-loop-func */

/* eslint-disable no-cond-assign */
import PropTypes from 'prop-types';
import React from 'react';
import BasicDropdown from '../BasicDropdown';
import DropdownKernel from './Dropdown';
export default function Dropdown(props) {
  return /*#__PURE__*/React.createElement(DropdownKernel, props);
}
Dropdown.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  onUpdate: PropTypes.func,
  render: PropTypes.func,
  placement: PropTypes.oneOf(['top', 'topLeft', 'topRight', 'bottom', 'bottomLeft', 'bottomRight']),
  showArrow: PropTypes.bool,
  arrowPointAtCenter: PropTypes.bool,
  margin: PropTypes.number,
  dropdownShadow: PropTypes.bool,
  size: PropTypes.oneOf(['mini', 'small', 'middle', 'large'])
};
Dropdown.defaultProps = {
  id: null,
  className: '',
  onUpdate: function onUpdate() {},
  render: BasicDropdown,
  placement: 'bottomLeft',
  showArrow: false,
  arrowPointAtCenter: false,
  margin: undefined,
  dropdownShadow: true,
  size: null
};